import React from 'react';
import {
  ViewButton,
  ViewLeadButton,
} from '../Common/DataTable/tableActionButtons';
import moment from 'moment';

const createTableColumns = (openUserModal, openViewModal) => [
  {
    title: 'Ricavo',
    name: 'amount',
    width: 150,
    formatterComponent: ({ value }) => `€ ${value}`,
  },
  {
    title: 'Sconto',
    name: 'stripeCouponId',
    width: 120,
    formatterComponent: ({ value }) => value || 'N/A',
  },
  {
    title: 'Stripe',
    name: 'stripeSubscriptionId',
    width: 200,
    formatterComponent: ({ value }) => (
      <button
        className="btn btn-sm btn-outline-primary"
        onClick={() =>
          window.open(
            `${process.env.REACT_APP_STRIPE_BASE_URL}/subscriptions/${value}`,
            '_blank',
          )
        }>
        Stripe Subscription
        <i className="bx bx-link-external ml-1"></i>
      </button>
    ),
  },
  {
    title: 'Data ultimo pagamento',
    name: 'lastBillingDate',
    width: 150,
    getCellValue: (row) => moment(row.lastBillingDate).format('DD/MM/YYYY'),
  },
  {
    title: 'Data prossimo pagamento',
    name: 'nextBillingDate',
    width: 150,
    getCellValue: (row) => moment(row.nextBillingDate).format('DD/MM/YYYY'),
  },
  {
    title: 'Data inizio abbonamento',
    name: 'createdAt',
    width: 150,
    getCellValue: (row) => moment(row.lastBillingDate).format('DD/MM/YYYY'),
  },
  {
    title: 'ICC User ID',
    name: 'iccUserId',
    width: 120,
    hidden: true,
  },
  {
    title: 'ICC Subscription ID',
    name: 'iccSubscriptionId',
    width: 120,
    hidden: true,
  },

  {
    title: 'Action',
    name: 'action',
    width: 140,
    align: 'center',
    formatterComponent: ({ row }) => (
      <ul className="list-inline font-size-20 contact-links mb-0">
        {openViewModal && <ViewButton row={row} onPress={openViewModal} />}
        {openUserModal && <ViewLeadButton row={row} onPress={openUserModal} />}
      </ul>
    ),
    filter: 'disabled',
    sorting: 'disabled',
  },
];

export default createTableColumns;
